module.exports = __webpack_public_path__ + "img/check-square.2020b309.svg";